"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imoCodeDescriptions = void 0;
var imoCodeDescriptions = {
    "74183": {
        codeType: "CPT",
        code: "74183",
        description: "MRI ABDOMEN W/O & W/CONTRAST MATERIAL",
        shortDescription: "MRI ABDOMEN W/O & W/DYE",
        tenantDefined: true
    },
    "R16.0": {
        codeType: "ICD",
        code: "R16.0",
        description: "Hepatomegaly, not elsewhere classified",
        shortDescription: "Hepatomegaly, not elsewhere classified",
        tenantDefined: true
    },
    "25": {
        codeType: "MODIFIER",
        code: "25",
        description: "Significant, Separately Identifiable Evaluation and Management Service by the Same Physician or Other Qualified Health Care Professional on the Same Day of the Procedure or Other Service",
        shortDescription: null,
        tenantDefined: true
    },
    "26": {
        codeType: "MODIFIER",
        code: "26",
        description: "Professional Component",
        shortDescription: null,
        tenantDefined: true
    },
    "D11.7": {
        codeType: "ICD",
        code: "D11.7",
        description: "Benign neoplasm of other major salivary glands",
        shortDescription: "Benign neoplasm of other major salivary glands",
        tenantDefined: true
    },
    LT: {
        codeType: "MODIFIER",
        code: "LT",
        description: "Left side (used to identify procedures performed on the left side of the body)",
        shortDescription: null,
        tenantDefined: true
    },
    "D11.9": {
        codeType: "ICD",
        code: "D11.9",
        description: "Benign neoplasm of major salivary gland, unspecified",
        shortDescription: "Benign neoplasm of major salivary gland, unspecified",
        tenantDefined: true
    },
    "70450": {
        codeType: "CPT",
        code: "70450",
        description: "CT HEAD/BRAIN W/O CONTRAST MATERIAL",
        shortDescription: "CT HEAD/BRAIN W/O DYE",
        tenantDefined: true
    },
    "Z01.01": {
        codeType: "ICD",
        code: "Z01.01",
        description: "Encounter for examination of eyes and vision with abnormal findings",
        shortDescription: "Encounter for exam of eyes and vision w abnormal findings",
        tenantDefined: true
    },
    GC: {
        codeType: "MODIFIER",
        code: "GC",
        description: "This service has been performed in part by a resident under the direction of a teaching physician",
        shortDescription: null,
        tenantDefined: true
    },
    "B02.1": {
        codeType: "ICD",
        code: "B02.1",
        description: "Zoster meningitis",
        shortDescription: "Zoster meningitis",
        tenantDefined: true
    }
};
exports.imoCodeDescriptions = imoCodeDescriptions;
//# sourceMappingURL=code-descriptions.js.map